import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import { CircularProgress, Grid2 as Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import {
	getCatalogPhaseEventTypes,
	getPhaseEventTypes,
} from "../../data-entry/repositories/eaf.repositories";
import { useCatalogPhaseEventsContext } from "./CatalogPhaseEventsContext";
import { TablePhaseEvents } from "./components/TablePhaseEvents";

type Props = {};
export const CatalogPhaseEventsPage = (props: Props) => {
	const { state, actions } = useCatalogPhaseEventsContext();
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");

	const getPhaseEventsFromAPI = async () => {
		setIsLoading(true);
		const resp = await getCatalogPhaseEventTypes();
		if (resp.ok) {
			actions.setPhaseEvents(resp.data.tables[0].rows);
			setIsLoading(false);
		} else {
			setError(resp.message);
		}
	};

	useEffect(() => {
		getPhaseEventsFromAPI();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	if (state.phaseEvents) {
		return (
			<>
				<HelmetDexteel title="Phase Events - Configurations" />
				<Grid container justifyContent="center" alignItems="center">
					<Grid size={{ xs: 12, md: 12 }} style={{ margin: 0 }}>
						<Paper
							elevation={0}
							style={{
								width: "100%",
								padding: "15px 20px 10px",
								borderRadius: "0.75rem",
							}}
						>
							<TablePhaseEvents
								isLoading={isLoading}
								getPhaseEventsFromAPI={getPhaseEventsFromAPI}
							/>
						</Paper>
					</Grid>
				</Grid>
				<ErrorModal error={error} onHide={() => setError("")} />
			</>
		);
	}
	return (
		<Grid
			size={{ xs: 12 }}
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "70vh",
			}}
		>
			<CircularProgress />
		</Grid>
	);
};
